import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { UserService } from './../shared/user.service';
import { Component, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import * as $ from 'jquery';
import { UsuariosListComponent } from './usuarios-list.component';
import * as myGlobals from './../global';
import { NgxSpinnerService } from 'ngx-spinner';
import { HttpErrorValidator } from '../services/http-error-validator';

@Component({
  selector: 'pm-usuarios',
  templateUrl: './usuarios.component.html',
  styleUrls: ['./usuarios.component.sass']
})
export class UsuariosComponent implements OnInit, OnDestroy, AfterViewInit {
  public pageTitle = 'Login';

  // users: User[] = [];
  errorMessage = '';
  currentPg = 1;

  constructor(
    public service: UserService,
    private parent: UsuariosListComponent,
    private router: Router,
    private spinnerService: NgxSpinnerService,
    private httpErrorValidator: HttpErrorValidator
  ) {}

  ngOnInit(): void {
    console.log('Entrando a Init<LIST>');
    this.service.list = this.service.allUsers();

    this.service.allUsers().subscribe(err => this.httpErrorValidator.validateError(err));

    this.spinner();
  }

  ngAfterViewInit() {
    $('a[rel=usuarios]').addClass('selected');
  }

  newUsuario(): void {
    this.parent.showUsuarios = false;
    this.parent.showAddUsuario = true;
    this.parent.showEditUsuario = false;
  }

  edit(id: number) {
    console.log('UsuariosComponent: edit: id: ', id);
    // this.parent.editnumber = index;
    // console.log(this.parent.editnumber+","+index);
    // console.log(elemento.roles[index]);
    this.parent.editnumber = id;
    this.parent.showUsuarios = false;
    this.parent.showAddUsuario = false;
    this.parent.showEditUsuario = true;
  }

  public spinner(): void {
    this.spinnerService.show();
    setTimeout(() => {
      this.spinnerService.hide();
    }, 300);
  }

  ngOnDestroy() {
    $('a[rel=usuarios]').removeClass('selected');
  }
}
